export interface IUIState {
  queue: number;
  loading: boolean;
  showError: boolean;
  errorMessage: string;
  showSuccess: boolean;
  successMessage: string;
  description: string;
  duration: number | null;
  newBookingActive: boolean;
  editBookingActive: boolean;
  editBookingStartTab: number | null;
  newLotteryRequestActive: boolean;
  showInfo: boolean;
  infoMessage: string;
  infoLoading: boolean;
}

export interface IUIAction {
  type: string;
  payload: any;
}

const initialState: IUIState = {
  queue: 0,
  loading: false,
  showError: false,
  errorMessage: "",
  showSuccess: false,
  successMessage: "",
  description: "",
  duration: null,
  newBookingActive: false,
  editBookingActive: false,
  editBookingStartTab: null,
  newLotteryRequestActive: false,
  showInfo: false,
  infoMessage: "",
  infoLoading: false,
};

export default function UIReducer(state = initialState, action: IUIAction) {
  switch (action.type) {
    case "loading":
      return {
        ...state,
        loading: action.payload,
      };
    case "modify.queue":
      return {
        ...state,
        queue: action.payload,
      };
    case "error.show":
      return {
        ...state,
        showError: true,
        errorMessage: action.payload.errorMessage,
        duration: action.payload.duration,
      };
    case "error.close":
      return {
        ...state,
        showError: false,
        errorMessage: "",
        duration: null,
      };
    case "success.show":
      return {
        ...state,
        showSuccess: true,
        successMessage: action.payload.successMessage,
        duration: action.payload.duration,
        description: action.payload.description,
      };
    case "success.close":
      return {
        ...state,
        showSuccess: false,
        successMessage: "",
        duration: null,
      };
    case "info.show":
      return {
        ...state,
        showInfo: true,
        infoMessage: action.payload.infoMessage,
        duration: action.payload.duration,
        description: action.payload.description,
        infoLoading: action.payload.loading,
      };
    case "info.close":
      return {
        ...state,
        showInfo: false,
        infoMessage: "",
        duration: null,
        infoLoading: false,
      };

    case "booking.initiate":
      return {
        ...state,
        newBookingActive: true,
      };

    case "booking.close":
      return {
        ...state,
        newBookingActive: false,
      };

    case "editBooking.initiate":
      return {
        ...state,
        editBookingActive: true,
        editBookingStartTab: action.payload.editBookingStartTab,
      };

    case "editBooking.close":
      return {
        ...state,
        editBookingActive: false,
      };

    case "newLotteryRequest.initiate":
      return {
        ...state,
        newLotteryRequestActive: true,
      };

      case "newLotteryRequest.close":
        return {
          ...state,
          newLotteryRequestActive: false,
      };

    default:
      return state;
  }
}
